import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_CHECK,
  AUTH_ERROR,
} from 'react-admin';

import jwt from 'jsonwebtoken';

import { API_AUTH_LOGIN_URL } from './urls';
import callWebApi from './callWebApi';


const AUTH_TOKEN_KEY = 'authToken';


export const setAuthToken = token => localStorage.setItem(AUTH_TOKEN_KEY, token);
export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);
export const removeAuthToken = () => localStorage.removeItem(AUTH_TOKEN_KEY);
export const getUser = () => {
  const token = getAuthToken();
  if (token) {
    const { user } = jwt.decode(token);
    return user;
  }
  return null;
};

/**
 * Types of admin levels and their access:
 *  - Full: Allow full access to view/edit any resource
 *  - Supervisor: Able to update basic customer info (Address, telephone, email, etc.),
 *      edit sutability info, and approve user resources
 *  - Regular: Able to only update basic customer info (Address, telephone, email, etc.)
 *      and sutability info
 *  - Read only: Allows for only viewing resources
 */
export const ADMIN_LEVELS = {
  FULL_ADMIN: 'full_admin',
  SUPERVISOR_ADMIN: 'supervisor_admin',
  REGULAR_ADMIN: 'regular_admin',
  READ_ONLY_ADMIN: 'read_only_admin',
};


export const getAdminLevel = () => {
  const user = getUser();
  if (user && user.role) {
    return ADMIN_LEVELS[user.role.toUpperCase()];
  }
  return null;
};

export default async (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username, password } = params;
    const { token } = await callWebApi('POST', API_AUTH_LOGIN_URL, {
      email: username,
      passphrase: password,
      includeRole: true,
    });
    const { user } = jwt.decode(token);
    if (!user || !user.role || !ADMIN_LEVELS[user.role.toUpperCase()]) {
      throw new Error('User not an admin');
    }
    setAuthToken(token);
    return;
  } else if (type === AUTH_LOGOUT) {
    removeAuthToken();
    return;
  } else if (type === AUTH_CHECK) {
    const decodedToken = jwt.decode(getAuthToken());
    if (new Date(decodedToken.exp * 1000) - new Date() > 0) {
      return;
    }
    removeAuthToken();
    throw new Error('Token expired');
  } else if (type === AUTH_ERROR) {
    // The react-admin docs:
    //
    //    https://marmelab.com/react-admin/DataProviders.html#error-format
    //
    // say that if dataProvider throws error that is not 401 or 403 it will
    // show a notification. This is not accurate as any dataProvider error
    // will redirect to login screen.
    // To prevent logout on non-auth error watch for AUTH_ERROR which is passed
    // to this authProvider on FETCH_ERROR and ignore non-401, non-403 errors.
    // These non-auth errors are passed to a custom saga (src/fetchErrorSaga.js)
    // which shows a notification.
    const err = params;
    if (err.status && (err.status === 401 || err.status === 403)) {
      throw err;
    }
    return;
  }
  throw new Error(`Unknown type ${type}`);
};



// WEBPACK FOOTER //
// ./src/authProvider.js